/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ImageResponse } from '../../models/image-response';

export interface GetImagesByTypeAndId$Params {

/**
 * Type of the referenced entity
 */
  type: 'PRODUCT' | 'CONTAINER' | 'PACKAGE';

/**
 * ID of the referenced entity
 */
  id: string;
}

export function getImagesByTypeAndId(http: HttpClient, rootUrl: string, params: GetImagesByTypeAndId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ImageResponse>>> {
  const rb = new RequestBuilder(rootUrl, getImagesByTypeAndId.PATH, 'get');
  if (params) {
    rb.query('type', params.type, {});
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ImageResponse>>;
    })
  );
}

getImagesByTypeAndId.PATH = '/images';
